export enum PERMISSIONS {
  // Is Admin
  JobRead = 'ADMIN_JOB_EXECUTION_READ',
  AdminReadContent = 'ADMIN_CONTENT_READ',
  // Docs
  DevDocumentationRead = 'DEV_DOCUMENTATION_READ',
  // password expiration
  PasswordExpirationRead = 'ADMIN_PASSWORD_EXPIRATION_EVENT_READ',
  PasswordExpirationCreate = 'ADMIN_PASSWORD_EXPIRATION_EVENT_CREATE',
  PasswordExpirationUpdate = 'ADMIN_PASSWORD_EXPIRATION_EVENT_UPDATE',
  PasswordExpirationDelete = 'ADMIN_PASSWORD_EXPIRATION_EVENT_DELETE',
  PasswordExpirationActivate = 'ADMIN_PASSWORD_EXPIRATION_EVENT_DELETE',
  PasswordExpirationDeactivate = 'ADMIN_PASSWORD_EXPIRATION_EVENT_DELETE',
  // user groups
  UserGroupRead = 'ADMIN_USER_GROUP_READ',
  UserGroupCreate = 'ADMIN_USER_GROUP_CREATE',
  UserGroupUpdate = 'ADMIN_USER_GROUP_UPDATE',
  UserGroupDelete = 'ADMIN_USER_GROUP_DELETE',
  UserGroupActivate = 'ADMIN_USER_GROUP_DELETE',
  UserGroupDeactivate = 'ADMIN_USER_GROUP_DELETE',
  UserSettingsRead = 'USER_SETTINGS_READ',
  UserSettingsUpdate = 'USER_SETTINGS_UPDATE',
  // domains
  DomainRead = 'ADMIN_DOMAIN_READ',
  DomainCreate = 'ADMIN_DOMAIN_CREATE',
  DomainUpdate = 'ADMIN_DOMAIN_UPDATE',
  DomainDelete = 'ADMIN_DOMAIN_DELETE',
  // users
  UserRead = 'ADMIN_USER_READ',
  UserCreate = 'ADMIN_USER_CREATE',
  UserUpdate = 'ADMIN_USER_UPDATE',
  UserDelete = 'ADMIN_USER_DELETE',
  // tenants
  TenantRead = 'ADMIN_TENANT_READ',
  TenantCreate = 'ADMIN_TENANT_EDIT',
  TenantDelete = 'ADMIN_TENANT_DELETE',
  TenantUpdate = 'ADMIN_TENANT_EDIT',
  // Holiday
  HolidayRead = 'ADMIN_HOLIDAY_READ',
  HolidayCreate = 'ADMIN_HOLIDAY_CREATE',
  HolidayUpdate = 'ADMIN_HOLIDAY_UPDATE',
  HolidayDelete = 'ADMIN_HOLIDAY_DELETE',
  HolidayActivate = 'ADMIN_HOLIDAY_DELETE',
  HolidayDeactivate = 'ADMIN_HOLIDAY_DELETE',

  // Distribution Lists
  DistributionListRead = 'ADMIN_DISTRIBUTION_LIST_READ',
  DistributionListUpdate = 'ADMIN_DISTRIBUTION_LIST_UPDATE',
  // Release notes ("What's New") authoring
  ReleaseNoteRead = 'ADMIN_RELEASE_NOTE_READ',
  ReleaseNoteCreate = 'ADMIN_RELEASE_NOTE_CREATE',
  ReleaseNoteUpdate = 'ADMIN_RELEASE_NOTE_UPDATE',
  ReleaseNotePublish = 'ADMIN_RELEASE_NOTE_PUBLISH',
  // Audit Reports
  ReadAuditReports = 'MARKET_DATA_AUDIT_REPORT_READ',
  ReadMarketData = 'MARKET_DATA_READ',
  // Event Logs section in Companies
  ReadEventLog = 'METRICS_EVENT_LOG_READ',
  // Roles
  RoleRead = 'ADMIN_ROLE_READ',
  RoleCreate = 'ADMIN_ROLE_CREATE',
  RoleEdit = 'ADMIN_ROLE_UPDATE',
  RoleDelete = 'ADMIN_ROLE_DELETE',
  // Companies
  CoreCompanyRead = 'CORE_COMPANY_READ',
  CoreCompanyCreate = 'CORE_COMPANY_CREATE',
  CoreCompanyUpdate = 'CORE_COMPANY_UPDATE',
  CoreCompanyDelete = 'CORE_COMPANY_DELETE',
  // Company Alerts
  CoreCompanyAlertRead = 'CORE_COMPANY_ALERT_READ',
  CoreCompanyAlertCreate = 'CORE_COMPANY_ALERT_CREATE',
  CoreCompanyAlertUpdate = 'CORE_COMPANY_ALERT_UPDATE',
  CoreCompanyAlertDelete = 'CORE_COMPANY_ALERT_DELETE',
  // Headlines
  HeadlinesRead = 'CORE_HEADLINE_READ',
  CoreCompanyAllowHeadlinesUpdate = 'CORE_COMPANY_ALLOW_HEADLINES_UPDATE',
  // Spaces
  CoreCompanySpaceRead = 'CORE_COMPANY_SPACE_READ',
  CoreSpaceThesisRead = 'CORE_SPACE_THESIS_READ',
  CoreSpaceThesisCreate = 'CORE_SPACE_THESIS_CREATE',
  CoreSpaceThesisDeleteDraft = 'CORE_SPACE_THESIS_CREATE',
  CoreSpaceThesisComplianceReview = 'CORE_SPACE_THESIS_COMPLIANCE_CREATE',
  CoreAllDraftRead = 'CORE_ALL_DRAFT_READ',
  // Milestones
  CoreMilestonesRead = 'CORE_MILESTONE_READ',
  CoreMilestonesCreate = 'CORE_MILESTONE_CREATE',
  CoreMilestonesUpdate = 'CORE_MILESTONE_UPDATE',
  CoreMilestonesDelete = 'CORE_MILESTONE_DELETE',
  CoreMilestoneEventRead = 'CORE_MILESTONE_EVENT_READ',
  // Company Links
  CoreLinkRead = 'CORE_LINK_READ',
  // Company identifiers
  CoreCompanyIdentifierRead = 'CORE_COMPANY_IDENTIFIER_COMPANY_READ',
  // Dashboard
  CorePortfolioRead = 'CORE_PORTFOLIO_READ',
  CorePortfolioCreate = 'CORE_PORTFOLIO_CREATE',
  // Portfolio
  CorePortfolioHistoryRead = 'CORE_PORTFOLIO_HISTORY_READ',
  CorePortfolioHistoryUpdate = 'CORE_PORTFOLIO_HISTORY_UPDATE',
  // Position Notes
  CorePortfolioPositionCreate = 'CORE_PORTFOLIO_POSITION_CREATE',
  CorePortfolioPositionUpdate = 'CORE_PORTFOLIO_POSITION_UPDATE',
  CorePortfolioPositionDelete = 'CORE_PORTFOLIO_POSITION_DELETE',
  // Financial
  CorePriceTargetRead = 'CORE_PRICE_TARGET_READ',
  CorePriceTargetUpdate = 'CORE_PRICE_TARGET_UPDATE',
  CoreCompanyFinancialRead = 'CORE_COMPANY_FINANCIAL_READ',
  CoreCompanyFinancialUpdate = 'CORE_COMPANY_FINANCIAL_UPDATE',
  CoreCompanyPricingRead = 'CORE_COMPANY_PRICING_READ',
  AdminSettingUpdate = 'ADMIN_SETTING_UPDATE',
  // Attachments
  CoreAttachmentsRead = 'CORE_ATTACHMENT_READ',
  CoreAttachmentsCreate = 'CORE_ATTACHMENT_CREATE',
  // products
  CoreProductCreate = 'CORE_PRODUCT_CREATE',
  CoreProductUpdate = 'CORE_PRODUCT_UPDATE',
  CoreProductRead = 'CORE_PRODUCT_READ',
  CoreProductInstanceRead = 'CORE_PRODUCT_INSTANCE_READ',
  CoreProductInstanceCreate = 'CORE_PRODUCT_INSTANCE_CREATE',
  CoreProductInstanceUpdate = 'CORE_PRODUCT_INSTANCE_UPDATE',
  CoreProductInstanceDelete = 'CORE_PRODUCT_INSTANCE_DELETE',
  // Index Companies
  CoreIndexCompanyRead = 'CORE_INDEX_COMPANY_READ',
  CoreIndexCompanyReloadHoldings = 'CORE_INDEX_COMPANY_RELOAD_HOLDINGS',
  // Notes
  CoreSpaceNoteRead = 'CORE_SPACE_NOTE_READ',
  CoreSpaceNoteCreate = 'CORE_SPACE_NOTE_CREATE',
  CoreSpaceNoteUpdate = 'CORE_SPACE_NOTE_UPDATE',
  // MNPI
  CoreSpaceNoteComplianceReview = 'CORE_SPACE_NOTE_COMPLIANCE_CREATE',
  // Prc/Vol Movers
  CorePriceVolumeMoversRead = 'CORE_PRCVOL_MOVERS_READ',
  CoreCompaniesDashboardRead = 'CORE_COMPANIES_DASHBOARD_READ',
  CoreInsightsRead = 'CORE_INSIGHT_READ',
  CoreReportsGeneratorRead = 'CORE_REPORTS_GENERATOR_READ',
  // search portal
  CoreSearchPortalRead = 'CORE_SEARCH_PORTAL_READ',
  // Indication
  CoreIndicationsRead = 'CORE_INDICATIONS_READ',
  CoreIndicationsCreate = 'CORE_INDICATIONS_CREATE',
  CoreIndicationsUpdate = 'CORE_INDICATIONS_UPDATE',
  CoreIndicationsDelete = 'CORE_INDICATIONS_DELETE',
  CoreIndicationsNoteRead = 'CORE_INDICATION_NOTE_READ',
  // Classification
  CoreClassificationsRead = 'CORE_CLASSIFICATIONS_READ',
  CoreClassificationsCreate = 'CORE_CLASSIFICATIONS_CREATE',
  CoreClassificationsUpdate = 'CORE_CLASSIFICATIONS_UPDATE',
  CoreClassificationsDelete = 'CORE_CLASSIFICATIONS_DELETE',
  // Notes
  CoreNotesRead = 'CORE_NOTES_READ',
  CoreNotesCreate = 'CORE_NOTES_CREATE',
  CoreNotesUpdate = 'CORE_NOTES_UPDATE',
  CoreNotesDelete = 'CORE_NOTES_DELETE',
  // exec dashboard
  ExecDashboardRead = 'CORE_COMPANY_DASHBOARD_READ',
  // Insights
  CoreInsightCreate = 'CORE_INSIGHT_CREATE',

  // Conferences
  CoreConferenceCreate = 'CORE_CONFERENCE_CREATE',
  CoreConferenceRead = 'CORE_CONFERENCE_READ',
  CoreConferenceUpdate = 'CORE_CONFERENCE_UPDATE',

  // Tags
  CurateTagsRead = 'ADMIN_CURATE_TAGS_READ',
  CurateTagsCreate = 'ADMIN_CURATE_TAGS_CREATE',
  CurateTagsUpdate = 'ADMIN_CURATE_TAGS_UPDATE',
  CurateTagsDelete = 'ADMIN_CURATE_TAGS_DELETE',

  // QRS
  QrsUpdate = 'QRS_LINKS_UPDATE',
  QrsCreate = 'QRS_LINKS_CREATE',
  QrsDelete = 'QRS_LINKS_UPDATE',
  QrsRead = 'QRS_LINKS_READ',
  QrsPrivilegedRead = 'QRS_LINKS_READ_PRIVILEGED',

  // Company Securities
  CoreSecuritiesRead = 'CORE_SECURITIES_READ',
  CoreSecuritiesCreate = 'CORE_SECURITIES_CREATE',
  CoreSecuritiesUpdate = 'CORE_SECURITIES_UPDATE',

  // Sonar
  CoreSonarNoteRead = 'CORE_SONAR_NOTE_READ',
  CoreSonarNoteCreate = 'CORE_SONAR_NOTE_CREATE',
  CoreSonarNoteUpdate = 'CORE_SONAR_NOTE_UPDATE',
  CoreSonarNoteDelete = 'CORE_SONAR_NOTE_DELETE',
  SonarRead = 'SONAR_READ',
  SonarCreate = 'SONAR_CREATE',
  SonarUpdate = 'SONAR_UPDATE',

  // AI
  AiGptNotesRead = 'AI_GPT_NOTES_READ',

  // General read
  CoreFundingsRead = 'CORE_FUNDINGS_READ',

  // Trade Restrictions and Board Seats
  TradeRestrictionRead = 'TRADE_RESTRICTION_READ',
  TradeRestrictionLimitedRead = 'TRADE_RESTRICTION_LIMITED_READ',
  TradeRestrictionCreate = 'TRADE_RESTRICTION_CREATE',
  TradeRestrictionUpdate = 'TRADE_RESTRICTION_UPDATE',
  TradeRestrictionDelete = 'TRADE_RESTRICTION_DELETE',
  BoardRestrictionRead = 'BOARD_RESTRICTION_READ',
  BoardRestrictionCreate = 'BOARD_RESTRICTION_CREATE',
  BoardRestrictionUpdate = 'BOARD_RESTRICTION_UPDATE',
  BoardRestrictionDelete = 'BOARD_RESTRICTION_DELETE',

  // Slide Deck Comparison
  CoreSlideDeckComparisonRead = 'CORE_SLIDE_DECK_COMPARISON_READ',
  CoreSlideDeckComparisonRequest = 'CORE_SLIDE_DECK_COMPARISON_REQUEST',
  // RA-2703. Deliberately NOT CORE_SLIDE_DECK_COMPARISON_DELETE, which gates the service-account S3
  // object delete. Seeded INSERT-only, so every analyst 403s until an admin assigns it per environment.
  CoreSlideDeckDelete = 'CORE_SLIDE_DECK_DELETE',

}
